export default __webpack_public_path__ + "static/media/TopBanner.4514f72d.png";